import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import * as Icons from '../../components/Admin/AdminLogos';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';
const DefaultIcon = Icons.HomeLogo;
const SUPER_ADMIN_EMAIL = 'superduper@admin.com';

const allMenuItems = [
    { path: '/admin/dashboard', icon: 'HomeLogo', label: 'Home' },
    { path: '/admin/dashboard/admin-management', icon: 'AdminManagement', label: 'Admin Management' },
    { path: '/admin/dashboard/user-management', icon: 'UserManagement', label: 'User Management' },
    { path: '/admin/dashboard/whatsapp-manager-management', icon: 'WhatsAppManagerLogo', label: 'WhatsApp Managers' },
    { path: '/admin/dashboard/sms-gateway-routes', icon: 'GatewayRoutes', label: 'Routes Management' },
    { path: '/admin/dashboard/blacklist', icon: 'Blacklist', label: 'Blacklisted Numbers' },
    { path: '/admin/dashboard/user-rates', icon: 'UserRatesLogo', label: 'User Rates' },
    { path: '/admin/dashboard/global-rates', icon: 'GlobalRates', label: 'Global Rates' },
    { path: '/admin/dashboard/transfer-credit', icon: 'CreditLogo', label: 'Credit Management' },
    { path: '/admin/dashboard/transfer-credit-history', icon: 'TransferHistory', label: 'Credit Transfer History' },
    { path: '/admin/dashboard/sms-analytics', icon: 'SmsTraffic', label: 'SMS Analytics' },
    { path: '/admin/dashboard/sms-campaign', icon: 'SMSCampaignLogo', label: 'SMS Campaign Report' },
    { path: '/admin/dashboard/sms-transaction-report', icon: 'SMSReport', label: 'SMS Transaction Report' },
    { path: '/admin/dashboard/spam-report', icon: 'SpamLogo', label: 'Spam Report' },
    { path: '/admin/dashboard/activity-log', icon: 'ActivityLog', label: 'Activity Log' },
];

const perkesoMenuItems = [
    { path: '/admin/dashboard', icon: 'HomeLogo', label: 'Home' },
    { path: '/admin/dashboard/user-management', icon: 'UserManagement', label: 'User Management' },
    { path: '/admin/dashboard/whatsapp-managers', icon: 'UserManagement', label: 'WhatsApp Managers' },
    { path: '/admin/dashboard/blacklist', icon: 'Blacklist', label: 'Blacklisted Numbers' },
    { path: '/admin/dashboard/transfer-credit', icon: 'CreditLogo', label: 'Credit Management' },
    { path: '/admin/dashboard/transfer-credit-history', icon: 'SMSReport', label: 'Credit Transfer History' },
    { path: '/admin/dashboard/sms-analytics', icon: 'SmsTraffic', label: 'SMS Analytics' },
    { path: '/admin/dashboard/sms-campaign', icon: 'SMSCampaignLogo', label: 'SMS Campaign Report' },
    { path: '/admin/dashboard/sms-transaction-report', icon: 'SMSReport', label: 'SMS Transaction Report' },
    { path: '/admin/dashboard/activity-log', icon: 'ActivityLog', label: 'Activity Log' },
];

const AdminSidebarItems = ({ sidebarShow }) => {
    const { email } = useSelector((state) => state.auth.user);
    const { pathname } = useLocation();

    const menuItems = useMemo(() => {
        if (email === SUPER_ADMIN_EMAIL) return allMenuItems;
        return white_label_perkeso ? perkesoMenuItems : allMenuItems;
    }, [email]);

    const renderNavItem = useMemo(() => (item) => {
        const Icon = Icons[item.icon] || DefaultIcon;

        const isActive = !item.external && pathname === item.path;
        const linkProps = item.external
            ? { as: 'a', href: item.path, target: '_blank', rel: 'noopener noreferrer' }
            : { as: Link, to: item.path };

        const content = (
            <>
                <span className="nav-icon">
                    <Icon />
                </span>
                <span className="toggle-name">{item.label}</span>
            </>
        );

        const navLink = (
            <Nav.Link {...linkProps} active={isActive}>
                {content}
            </Nav.Link>
        );

        return (
            <Nav.Item as="li" key={item.path}>
                {sidebarShow ? (
                    navLink
                ) : (
                    <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id={`nav-${item.label.toLowerCase()}`}>{item.label}</Tooltip>}
                    >
                        {navLink}
                    </OverlayTrigger>
                )}
            </Nav.Item>
        );
    }, [pathname, sidebarShow]);

    return (
        <Nav as="ul" className="responsive-scroll">
            {menuItems.map(renderNavItem)}
        </Nav>
    );
};

export default AdminSidebarItems;